interface MaterialIconProps {
    name: string;
    fill?: boolean;
    weight?: number;
    className?: string;
}

const MaterialIcon = ({ name, fill = false, weight = 400, className = "" }: MaterialIconProps) => (
    <span
        className={`material-symbols-outlined select-none ${className}`}
        style={{ fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24` }}
    >
        {name}
    </span>
);

export default MaterialIcon;
